let language = {
    /************************************ 03:产品 ************************************/
    /***** B:业务错误 *******/
    // 用户未登录--添加产品到店铺
    A103B001: "用户登录后只能向商店添加产品",
    // 产品属性验证失败
    A103B002: "产品属性验证失败。请查看当前产品属性",
    // 产品名称处于编辑状态
    A103B003: "请确认店铺产品名称！",
    // 添加产品到店铺，选中店铺不能为空
    A103B004: "所选店铺不能为空！",
    // 添加产品到店铺，存在重复添加产品店铺
    A103B005: "当前选择的商品商店中有重复的商品商店！",
    // 添加产品到店铺，partner未进行邮箱验证
    A103B006: "请先验证合作伙伴邮箱后添加产品",
    // 产品属性校验失败
    "A103B007": '产品属性错误',
    // 必填属性，为空
    "A103B008": '产品属性验证失败。请刷新。如果问题仍然存在，请联系我们：{{supportmail}}',
    // 产品页面缺失
    "A103B009": '产品页面缺失',
    // 产品页面缺失，请重新发布产品页
    "A103B0010": '该产品页面尚未发布，请到网站后台发布产品',
    // 非完备产品
    "A103B0011": "产品不完整",
    // 非完备产品,不能直接添加到购物车
    "A103B0012": "不完整的商品无法直接添加到购物车",
    // 产品购买数量无效（成品产品）
    "A103B0013": "购买的产品数量",
    // 您当前的购买数量不符合,产品当前支持的购买数量期间为1-9999。
    "A103B0014": "您当前的购买数量不匹配，该产品目前支持购买数量期间为1-99999 ",
    "A103B0015": "产品价格获取失败",
    "A103B0016": "目前不支持 {{storeProductType}} 商店产品类型，请联系管理员",
    "A103B0017": `',公式计算时出现错误'`,
    "A103B0018": "由于缺少产品属性表单数据，计算产品运输成本出错。",
    "A103B200001": "计算运费时找不到该产品。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    "A103B2000033": "计算运费时产品属性出现问题。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    "A103B4000061": "计算运费时产品重量出现问题。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    "A103B4000063": "计算运费时，运费 API 出现问题。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    "A103B30000027": "计算运费时，运输天数出现问题。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    "A103B300310": "系统中不存在货币 {{currentCurrency}}。",
    "A103B3000601": "当前货币: {{currentCurrency}}, {{appName}}平台支持的货币类型：: {{supportCurrencies}}。",

};

export { language }